import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7914b891&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=7914b891&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914b891",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7914b891')) {
      api.createRecord('7914b891', component.options)
    } else {
      api.reload('7914b891', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=7914b891&scoped=true", function () {
      api.rerender('7914b891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type_5/Footer.vue"
export default component.exports